import { ReactNode, createContext } from 'react';
import useLocalStorage from '~/hooks/useLocalStorage';
import {
  OpportunitiesSearchParams,
  OpportunitiesSearchParamsContextState,
} from './types/opportunities/searchParams';
import { useConstants } from './constants/opportunities/constants';

const initialState: OpportunitiesSearchParamsContextState = {
  defaultValues: {} as OpportunitiesSearchParams,
  searchParams: {} as OpportunitiesSearchParams,
  setSearchParams: () => {},
};

const OpportunitiesSearchParamsContext = createContext(initialState);

type OpportunitiesSearchParamsProviderProps = {
  children: ReactNode;
};

function OpportunitiesSearchParamsProvider({ children }: OpportunitiesSearchParamsProviderProps) {
  const { defaultValues } = useConstants();

  const [searchParams, setSearchParams] = useLocalStorage<OpportunitiesSearchParams>(
    'searchParams:opportunities',
    defaultValues
  );

  return (
    <OpportunitiesSearchParamsContext.Provider
      value={{ searchParams, setSearchParams, defaultValues }}
    >
      {children}
    </OpportunitiesSearchParamsContext.Provider>
  );
}

export { OpportunitiesSearchParamsProvider, OpportunitiesSearchParamsContext };
